/**
 * English - `reportText`: the words the reports say about themselves - titles,
 * descriptions, categories, columns, filters and their options, KPIs, charts -
 * keyed by the English the server writes them in. Read through
 * `features/reporting/lib/reportText.ts`, which shows the server's own words
 * for any phrase not listed here. English maps every phrase to itself so the
 * two files keep the same keys.
 */
const reportText: Record<string, string> = {
  'Across this page\'s customers': 'Across this page\'s customers',
  'Active': 'Active',
  'Added': 'Added',
  'All time, across every customer': 'All time, across every customer',
  'Amount': 'Amount',
  'Archived': 'Archived',
  'At or below threshold': 'At or below threshold',
  'Authorized': 'Authorized',
  'Available': 'Available',
  'Average per order': 'Average per order',
  'Bought once': 'Bought once',
  'By status': 'By status',
  'Cancelled': 'Cancelled',
  'Catalogue': 'Catalogue',
  'Catalogue by status': 'Catalogue by status',
  'Categories': 'Categories',
  'Category': 'Category',
  'Category id': 'Category id',
  'Charged to shoppers, before any courier cost': 'Charged to shoppers, before any courier cost',
  'Click a bar to open that category\'s products.':
    'Click a bar to open that category\'s products.',
  'Click a bar to open that product.': 'Click a bar to open that product.',
  'Click a slice to list those customers.': 'Click a slice to list those customers.',
  'Click a slice to open those orders.': 'Click a slice to open those orders.',
  'Cod': 'Cod',
  'Code': 'Code',
  'Code filter': 'Code filter',
  'Collected against failed': 'Collected against failed',
  'Confirmed': 'Confirmed',
  'Confirmed through delivered': 'Confirmed through delivered',
  'Customer': 'Customer',
  'Customer activity': 'Customer activity',
  'Customer id': 'Customer id',
  'Customers': 'Customers',
  'Delivered': 'Delivered',
  'Discount': 'Discount',
  'Discount given': 'Discount given',
  'Discounts & coupons': 'Discounts & coupons',
  'Draft': 'Draft',
  'Email': 'Email',
  'Ended': 'Ended',
  'Every gateway attempt, what cleared, and what failed.':
    'Every gateway attempt, what cleared, and what failed.',
  'Every order in the window, down to the record.':
    'Every order in the window, down to the record.',
  'Everybody on file, with lifetime value and how often they return.':
    'Everybody on file, with lifetime value and how often they return.',
  'Everything that went backwards, and what it cost.':
    'Everything that went backwards, and what it cost.',
  'Failed': 'Failed',
  'Failure': 'Failure',
  'Finance': 'Finance',
  'GST collected by rate and HSN, for the window you file on.':
    'GST collected by rate and HSN, for the window you file on.',
  'GST rate': 'GST rate',
  'Has a storefront account': 'Has a storefront account',
  'Highest lifetime spend': 'Highest lifetime spend',
  'Highest revenue': 'Highest revenue',
  'Highest spend': 'Highest spend',
  'Highest stock first': 'Highest stock first',
  'Highest value': 'Highest value',
  'HSN': 'HSN',
  'In stock': 'In stock',
  'Includes the methods that never reach a gateway.':
    'Includes the methods that never reach a gateway.',
  'Inventory': 'Inventory',
  'Joined': 'Joined',
  'Joined in this window': 'Joined in this window',
  'Largest first': 'Largest first',
  'Last order': 'Last order',
  'Lifetime spend': 'Lifetime spend',
  'Lowest revenue': 'Lowest revenue',
  'Lowest stock': 'Lowest stock',
  'Lowest stock first': 'Lowest stock first',
  'Lowest value': 'Lowest value',
  'Marketing': 'Marketing',
  'Method': 'Method',
  'Most given away': 'Most given away',
  'Most orders': 'Most orders',
  'Most recent': 'Most recent',
  'Most recent order': 'Most recent order',
  'Most revenue': 'Most revenue',
  'Most units': 'Most units',
  'Most used': 'Most used',
  'Name A-Z': 'Name A-Z',
  'Never ordered': 'Never ordered',
  'New customers': 'New customers',
  'Newest first': 'Newest first',
  'No categories yet.': 'No categories yet.',
  'No customers match these filters.': 'No customers match these filters.',
  'No discounts were used in this window.': 'No discounts were used in this window.',
  'No orders in this window yet.': 'No orders in this window yet.',
  'No orders match these filters.': 'No orders match these filters.',
  'No products match these filters.': 'No products match these filters.',
  'No tax was charged in this window.': 'No tax was charged in this window.',
  'No transactions in this window.': 'No transactions in this window.',
  'Nobody bought in this window.': 'Nobody bought in this window.',
  'Not tracked': 'Not tracked',
  'Nothing sold in this window.': 'Nothing sold in this window.',
  'Nothing tracked yet.': 'Nothing tracked yet.',
  'Nothing was cancelled or returned in this window.':
    'Nothing was cancelled or returned in this window.',
  'Of every attempt in the window': 'Of every attempt in the window',
  'Of every customer on file': 'Of every customer on file',
  'Of what the baskets would have been': 'Of what the baskets would have been',
  'Oldest first': 'Oldest first',
  'On hand': 'On hand',
  'One-off against repeat': 'One-off against repeat',
  'Only orders that became money. Click a point to open that day.':
    'Only orders that became money. Click a point to open that day.',
  'Opted in to marketing': 'Opted in to marketing',
  'Order': 'Order',
  'Order id': 'Order id',
  'Order status': 'Order status',
  'Orders': 'Orders',
  'Orders by status': 'Orders by status',
  'Orders in window': 'Orders in window',
  'Orders placed': 'Orders placed',
  'Out of stock': 'Out of stock',
  'Packed': 'Packed',
  'Paid': 'Paid',
  'Partially Refunded': 'Partially Refunded',
  'Payment': 'Payment',
  'Payment id': 'Payment id',
  'Payment method': 'Payment method',
  'Payment status': 'Payment status',
  'Payments & transactions': 'Payments & transactions',
  'Pending': 'Pending',
  'Phone': 'Phone',
  'Placed': 'Placed',
  'Price': 'Price',
  'Processing': 'Processing',
  'Product': 'Product',
  'Product id': 'Product id',
  'Product sales': 'Product sales',
  'Products': 'Products',
  'Provider': 'Provider',
  'RAZORPAY': 'RAZORPAY',
  'Razorpay': 'Razorpay',
  'Reference': 'Reference',
  'Refunded': 'Refunded',
  'Repeat buyers': 'Repeat buyers',
  'Reserved': 'Reserved',
  'Return Requested': 'Return Requested',
  'Returned': 'Returned',
  'Returns, refunds & cancellations': 'Returns, refunds & cancellations',
  'Revenue': 'Revenue',
  'Revenue and orders': 'Revenue and orders',
  'Revenue by category': 'Revenue by category',
  'Revenue by payment method': 'Revenue by payment method',
  'Revenue, orders and the basket, with everything that moved them.':
    'Revenue, orders and the basket, with everything that moved them.',
  'Sale price, not cost': 'Sale price, not cost',
  'Sales': 'Sales',
  'Sales overview': 'Sales overview',
  'Segment': 'Segment',
  'Share': 'Share',
  'Shipped': 'Shipped',
  'Shipping': 'Shipping',
  'SKU': 'SKU',
  'Spent in window': 'Spent in window',
  'State': 'State',
  'Status': 'Status',
  'Stock in and out': 'Stock in and out',
  'Stock level': 'Stock level',
  'Stock on hand, what is reserved, and what needs reordering.':
    'Stock on hand, what is reserved, and what needs reordering.',
  'Subtotal': 'Subtotal',
  'Tax': 'Tax',
  'Tax & fees': 'Tax & fees',
  'Tax by rate': 'Tax by rate',
  'Tax collected': 'Tax collected',
  'Taxable value': 'Taxable value',
  'The catalogue, with what each product sold in the window.':
    'The catalogue, with what each product sold in the window.',
  'Threshold': 'Threshold',
  'Through the gateway, in this window': 'Through the gateway, in this window',
  'Top products by revenue': 'Top products by revenue',
  'Total': 'Total',
  'Transactions': 'Transactions',
  'Transactions by provider': 'Transactions by provider',
  'Units': 'Units',
  'Units and revenue per product, ranked.': 'Units and revenue per product, ranked.',
  'Units sold': 'Units sold',
  'Value': 'Value',
  'Value not kept': 'Value not kept',
  'Variant': 'Variant',
  'What each code cost and what it brought in.': 'What each code cost and what it brought in.',
  'What the discounts brought with them': 'What the discounts brought with them',
  'Whatsapp': 'Whatsapp',
  'When': 'When',
  'Which parts of the shop are carrying the revenue.':
    'Which parts of the shop are carrying the revenue.',
  'Who bought in this window, and what they spent in it.':
    'Who bought in this window, and what they spent in it.',
};

export default reportText;
